import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_PROVIDER_PREFERENCE_QUERY from './GetProviderPreference.gql';

const parseResult = (result) => {
  const initialState = {
    uuid: '',
    userId: '',
    corporateProviderMpin: '',
    corporateProviderName: '',
    corporateProviderLastName: '',
    taxIdNumber: '',
    servicingProviderMpin: '',
    servicingProviderName: null,
    servicingProviderLastName: '',
  };

  const providerPreference = get(
    result,
    'core.providerPreferenceDetails.providerPreference'
  );

  return {
    ...initialState,
    ...providerPreference,
  };
};

export const useProviderPreferenceQuery = (options) => {
  const [queryResult, queryAction] = useQuery(GET_PROVIDER_PREFERENCE_QUERY, {
    ...options,
    // requestPolicy: 'no-cache',
    onCompleted: (result) => {
      if (result && result.body && result.body.data && options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};

export const formatVariables = (data) => {
  const { uuid, userPermissions, admin } = data;
  let adminData = {};

  if (Object.keys(admin).length > 0) {
    adminData = {
      ...(admin.role && { role: admin.role }),
      adminUser: admin.userRoles?.['admin-user'],
      ...(admin.provider && {
        provider: {
          corporateProviderLastName: admin.provider?.corporateProviderLastName,
          corporateProviderMpin: admin.provider?.corporateProviderMpin,
          corporateProviderName: admin.provider?.corporateProviderName,
          optumId: admin.provider?.optumId,
          organizationId: admin.provider?.organizationId,
          organizationName: admin.provider?.organizationName,
          servicingProviderFirstName:
            admin.provider?.servicingProviderFirstName,
          servicingProviderLastName: admin.provider?.servicingProviderLastName,
          servicingProviderMpin: admin.provider?.servicingProviderMpin,
          servicingProviderName: admin.provider?.servicingProviderName,
          taxIdNumber: admin.provider?.taxIdNumber,
        },
      }),
    };
  }

  return {
    uuid,
    userPermissions,
    admin: adminData,
  };
};
